import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

const OrientationDisplay = ({title, azimuth, zenith }) => {

     const myRef = useRef(null);

     const [width, setWidth] =  useState();
     const azimuthRotation = `rotate(${azimuth},${width/4},${width/4})`;
     const zenithRotation = `rotate(${zenith}, 3,${width/2-20})`;

     const pathString = `M 3 ${(width/2)-20} L 3 20 A ${(width/2)-20} ${(width/2)-20} 0 0 1 ${(width/2)-40} ${(width/2)-20} Z`;

     useEffect(() => {
          const element = myRef.current;
          const rect = element.getBoundingClientRect();
          
          setWidth(rect.width);
          
          const updateWindowSize = () => {
               const element = myRef.current;
               const rect = element.getBoundingClientRect();
               setWidth(rect.width);
          };

         window.addEventListener('resize', updateWindowSize);
         return () => {
           window.removeEventListener('resize', updateWindowSize);
         };

     }, []);

     return (

          <Grid
               style={{border:"1px solid #cccccc", padding:"2px", margin:"1px"}}
               container
               spacing={1}
          >
         	     <Grid 
                    ref={myRef}
         	          item
     		     lg={12}
                    md={12}
                    xl={12}
                    xs={12}
         	     >
                   <InputLabel shrink>{title}</InputLabel>
               </Grid>
                <Grid 
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={6}
               >
                    <svg width={width/2} height={width/2}>
                         {/* Compass Circle */}
                         <circle 
                              cx={width/4}
                              cy={width/4}
                              r={(width/4)-20}
                              fill="grey" 
                              stroke="black" 
                              strokeWidth="2" 
                         />
                         <text x="50%" y="12" textAnchor="middle">N</text>
                         <text x="50%" y="100%" textAnchor="middle">S</text>
                         <text x="10" y="50%" textAnchor="middle">W</text>
                         <text x={width/2-12} y="50%" textAnchor="middle">E</text>

                         {/* Azimuth Needle */}
                         <line
                              x1="50%"
                              y1="50%"
                              x2="50%"
                              y2="10%"
                              stroke="red"
                              strokeWidth="4"
                              transform={`${azimuthRotation}`}
                         />
                    </svg>
               </Grid>
               <Grid 
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={6}
               >
                    <svg width={width/2} height={width/2} style={{ margin:"1px"}}>
                         <path 
                              d={pathString}
                              fill="grey" 
                              stroke="black" 
                              strokeWidth="2"
                         />
                         <text x="15" y="12" text-anchor="middle">0&deg;</text>
                         <text x={width/2-24} y={width/2-12} text-anchor="middle">90&deg;</text>
                         <line
                              x1='3'
                              y1='15'
                              x2="3"
                              y2={width/2-20}
                              stroke="red"
                              strokeWidth="4"
                              transform={`${zenithRotation}`}
                         />
                    </svg>
               </Grid>
               <Grid 
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={6}
               >
                    <h3 style={{textAlign:'center'}}>Azimuth: {azimuth.toFixed(2)}&deg;</h3>
               </Grid>
                <Grid 
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={6}
               >
                    <h3  style={{textAlign:'center'}}>Zenith: {zenith.toFixed(2)}&deg;</h3>
               </Grid>
          </Grid>

     );

};

OrientationDisplay.propTypes = {
};
export default OrientationDisplay;
